module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-4.79b286f8.jpg";